// extracted by mini-css-extract-plugin
module.exports =  {"root":"Cr1V7zZUWJLwKhm23wwj","item":"NS9bJ4q3oLlHdyIoU2xT","tags":"BTCma84X4OftSe_ZmMQX"};